import { FC } from 'react'
import { Route, Routes } from 'react-router'
import { ReportPage } from './ReportPage'
import { Daily, DPReport, NewContractsReport, PL, UnshippedReport } from './reportsData'
import ReportsRoutes from './routes'

export const ReportsPage: FC = () => {
  return (
    <Routes>
      <Route path={ReportsRoutes.relativeDPR} element={<ReportPage reportData={DPReport} />}></Route>
      <Route path={ReportsRoutes.relativePL} element={<ReportPage reportData={PL} />}></Route>
      <Route path={ReportsRoutes.relativeDaily} element={<ReportPage reportData={Daily} />}></Route>
      <Route path={ReportsRoutes.relativeNewContracts} element={<ReportPage reportData={NewContractsReport} />}></Route>
      <Route path={ReportsRoutes.relativeUnshipped} element={<ReportPage reportData={UnshippedReport} />}></Route>
    </Routes>
  )
}
